export const API_URL = "https://api.sharemonkie.com/api";
export default API_URL;
